import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/graphics/featured_photos_wave.png'
import _imports_1 from '../../assets/images/graphics/featured_photos_title.png'
import _imports_2 from '../../assets/images/Gala/galacover.jpg'
import _imports_3 from '../../assets/images/Jazz_101/101cover.jpg'
import _imports_4 from '../../assets/images/weekly_jams/weekly_1.jpg'


const _withScopeId = n => (_pushScopeId("data-v-51995d94"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "featured_wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "wave",
  src: _imports_0
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "text",
  src: _imports_1
}, null, -1))
const _hoisted_5 = { class: "featured_photo" }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider albums" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "divider_text" }, [
    /*#__PURE__*/_createElementVNode("p", null, "albums")
  ])
], -1))
const _hoisted_8 = { class: "albums_container" }
const _hoisted_9 = { class: "album_row" }
const _hoisted_10 = { class: "album evnt1" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "e_title" }, "Formal Gala", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "e_desc" }, " Photos from our end of semester Gala, featuring performances from our Big Bands, Dinner, and a jazz jam to end off the night! A night of good music and even better company!! ", -1))
const _hoisted_13 = { class: "album evnt2" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "e_title" }, "Jazz 101", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "e_desc" }, " A snapshot of Jazz 101, our beginner jazz workshop for those looking to learn more about \"How to Jazz\"! Check out the link in our instagram bio for resources on getting started learning jazz. ", -1))
const _hoisted_16 = { class: "album evnt3" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "e_title" }, "weekly jam", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "e_desc" }, [
  /*#__PURE__*/_createTextVNode(" A peek into our weekly jams. Pictured: Execs, members and instruments galore. Not pictured: the occasional chaos, the intermittent "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("* squeaks *, the hubbub/flow of conversation and good company. ")
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider videos" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "divider_text" }, "videos")
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vid_container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "vid_desc" }, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.youtube.com/watch?v=gxxsWnqyZhg" }, " 2020 Project E-Jam ")
  ]),
  /*#__PURE__*/_createElementVNode("iframe", {
    class: "video",
    src: "https://www.youtube.com/embed/gxxsWnqyZhg",
    frameborder: "0",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
    allowfullscreen: ""
  })
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vid_container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "vid_desc" }, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://www.youtube.com/embed/YXw4z21t92w" }, " 2019 dancing with the stars ")
  ]),
  /*#__PURE__*/_createElementVNode("iframe", {
    class: "video",
    src: "https://www.youtube.com/embed/YXw4z21t92w",
    frameborder: "0",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
    allowfullscreen: ""
  })
], -1))

export function render(_ctx, _cache) {
  const _component_modal = _resolveComponent("modal")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("img", {
          class: "f_img",
          src: _ctx.currImg
        }, null, 8, _hoisted_6)
      ])
    ]),
    _hoisted_7,
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("img", {
            src: _imports_2,
            onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.modalImage && _ctx.modalImage(...args))),
            "modal-id": "card-0"
          }),
          _createVNode(_component_modal, { "modal-id": "card-0" }, {
            default: _withCtx(() => [
              _createTextVNode("Test 1")
            ]),
            _: 1
          }),
          _hoisted_12
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("img", {
            src: _imports_3,
            onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.modalImage && _ctx.modalImage(...args))),
            "modal-id": "card-1"
          }),
          _createVNode(_component_modal, { "modal-id": "card-1" }, {
            default: _withCtx(() => [
              _createTextVNode("Test 2")
            ]),
            _: 1
          }),
          _hoisted_15
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("img", {
            src: _imports_4,
            onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.modalImage && _ctx.modalImage(...args))),
            "modal-id": "card-2"
          }),
          _createVNode(_component_modal, { "modal-id": "card-2" }, {
            default: _withCtx(() => [
              _createTextVNode("Test 3")
            ]),
            _: 1
          }),
          _hoisted_18
        ])
      ])
    ]),
    _hoisted_19,
    _hoisted_20,
    _hoisted_21
  ]))
}